import React from 'react';

const Hero = () => {
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      const offsetTop = target.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Hi, I'm <span className="highlight">Wasay Mohammed Abdul</span>
            </h1>
            <p className="hero-subtitle">Computer Science Graduate | Software Engineer</p>
            <p className="hero-description">
              Passionate software developer with expertise in full-stack development, AI/ML, and building scalable solutions. 
              Recently graduated with a Master's in Computer Science from Texas State University. 
              Seeking opportunities in software development, software engineering, and full-stack development roles.
            </p>
            <div className="hero-buttons">
              <a href="#projects" className="btn btn-primary" onClick={(e) => handleNavClick(e, '#projects')}>
                View My Work
              </a>
              <a href="#contact" className="btn btn-secondary" onClick={(e) => handleNavClick(e, '#contact')}>
                Get In Touch
              </a>
              <a href="/Resume__Wasay__.pdf" download className="btn btn-resume">
                <i className="fas fa-download"></i> Resume
              </a>
            </div>
            <div className="social-links">
              <a href="https://github.com/Wasay-Dev100" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <i className="fab fa-github"></i>
              </a>
              <a href="https://www.linkedin.com/in/wasay191/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="mailto:wasaymohammed18@gmail.com" aria-label="Email">
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="/ProfilePic.jpeg" 
              alt="Wasay Mohammed Abdul" 
              className="profile-image"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="image-placeholder" style={{display: 'none'}}>
              <i className="fas fa-user"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

